import Add from "@material-symbols/svg-500/rounded/add.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const AddIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Add });
	return <Icon />;
};

export default memo(AddIcon);
